import React, { useEffect, useState } from "react";

//redux
import { connect, useDispatch, useSelector } from "react-redux";

//MUI
import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    Tooltip,
} from "@material-ui/core";
import { Cancel } from "@material-ui/icons";

//types
import { CLOSE_DAILY_DIAMOND_LIMIT_DIALOG } from "../../store/user/types";

//action
import { adjustDailyDiamondCap } from "../../store/user/action";

import { permissionError } from "../../util/Alert";

const UpdateDailyDiamondLimitDialog = (props) => {
    const dispatch = useDispatch();

    const { dailyDiamondLimitDialog, dailyDiamondLimitDialogData } = useSelector((state) => state.user);
    const hasPermission = useSelector((state) => state.admin.admin.flag);

    const [dailyLimit, setDailyLimit] = useState("");
    const [errors, setErrors] = useState({
        dailyLimit: "",
    });

    useEffect(() => {
        if (dailyDiamondLimitDialogData) {
            setDailyLimit(parseInt(dailyDiamondLimitDialogData?.dailyDiamond?.cap) || "");
        }
    }, [dailyDiamondLimitDialogData]);

    useEffect(
        () => () => {
            setDailyLimit("");
            setErrors({ dailyLimit: "" });
        },
        [dailyDiamondLimitDialog]
    );

    const closeDialog = () => {
        dispatch({ type: CLOSE_DAILY_DIAMOND_LIMIT_DIALOG });
    };

    const handleUpdateDailyLimit = (e) => {
        e.preventDefault();

        if (!dailyLimit.toString().trim()) {
            return setErrors({ dailyLimit: "Daily diamond limit is required!" });
        }

        const limit = parseInt(dailyLimit);
        if (isNaN(limit) || limit < 0) {
            return setErrors({ dailyLimit: "Please enter a valid positive number!" });
        }

        if (!hasPermission) return permissionError();

        props.adjustDailyDiamondCap(dailyDiamondLimitDialogData?._id, limit);
        closeDialog();
    };

    return (
        <>
            <Dialog
                open={dailyDiamondLimitDialog}
                aria-labelledby="responsive-dialog-title"
                onClose={closeDialog}
                disableBackdropClick
                disableEscapeKeyDown
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle id="responsive-dialog-title">
                    <span className="text-danger font-weight-bold h4">
                        Update Daily Diamond Limit
                    </span>
                </DialogTitle>

                <IconButton
                    style={{
                        position: "absolute",
                        right: 0,
                    }}
                >
                    <Tooltip title="Close">
                        <Cancel className="text-danger" onClick={closeDialog} />
                    </Tooltip>
                </IconButton>

                <DialogContent>
                    <div className="modal-body pt-1 px-1 pb-3">
                        <div className="d-flex flex-column">
                            <form>
                                <div className="form-group mt-4">
                                    <label className="mb-2 text-gray">Daily Diamond Limit</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Enter new daily diamond limit"
                                        value={dailyLimit}
                                        onChange={(e) => {
                                            setDailyLimit(e.target.value);
                                            if (!e.target.value.toString().trim()) {
                                                return setErrors({
                                                    ...errors,
                                                    dailyLimit: "Daily diamond limit is required!",
                                                });
                                            } else {
                                                const limit = parseInt(e.target.value);
                                                if (isNaN(limit) || limit < 0) {
                                                    return setErrors({
                                                        ...errors,
                                                        dailyLimit: "Please enter a valid positive number!",
                                                    });
                                                }
                                                return setErrors({
                                                    ...errors,
                                                    dailyLimit: "",
                                                });
                                            }
                                        }}
                                    />
                                    {errors.dailyLimit && (
                                        <div className="ml-2 mt-1">
                                            {errors.dailyLimit && (
                                                <div className="pl-1 text__left">
                                                    <span className="text-red">{errors.dailyLimit}</span>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>

                                <div className="mt-5">
                                    <button
                                        type="button"
                                        className="btn btn-outline-info ml-2 btn-round float__right icon_margin"
                                        onClick={closeDialog}
                                    >
                                        Close
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-round float__right btn-danger"
                                        onClick={handleUpdateDailyLimit}
                                        disabled={!dailyLimit.toString().trim() || errors.dailyLimit}
                                    >
                                        Update
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default connect(null, { adjustDailyDiamondCap })(UpdateDailyDiamondLimitDialog);
